import { render, staticRenderFns } from "./year.vue?vue&type=template&id=4a5164b5"
import script from "./year.vue?vue&type=script&lang=js"
export * from "./year.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/erp-flexible-web21_zo1Z/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a5164b5')) {
      api.createRecord('4a5164b5', component.options)
    } else {
      api.reload('4a5164b5', component.options)
    }
    module.hot.accept("./year.vue?vue&type=template&id=4a5164b5", function () {
      api.rerender('4a5164b5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Crontab/year.vue"
export default component.exports